






































import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { SwRadio } from '@libs-uuif/shared/sw-radio';
const cssPrefix: string = 'selectedUserUnit';
@Component({
  components : {
    SwRadio,
  },
  filters: {
    toUpperCase: (value: string) => {
      const [firstLetter, ...restLetters] = value.split('');
      return `${firstLetter.toUpperCase()}${restLetters.join('')}`;
    },
  },
})
export default class SelectedUserUnit extends SwExtendedVue {
  cssPrefix = cssPrefix;
  @Prop({ type: String, default: '', required: true })
  fullName: any;

  @Prop({ type: String, default: '', required: true })
  emailAddress: any;

  @Prop({ type: Boolean, default: false, required: true })
  selected: any;

  selectedUser: string = '';

  @Watch('selected', { immediate: true, deep: true })
  private onChangeSelect() {
    this.selectedUser = this.selected ? this.emailAddress : '';
  }

  created() {
    this.selectedUser = this.selected ?  this.emailAddress : '';
  }

  handleChange(): void {
    this.selectedUser = this.emailAddress || '';
    this.$emit('onChangeUser', this.emailAddress);
  }
}
